import Image from "next/image";
import Link from "next/link";
import { storeLogoQuery } from "../../graphql/storeLogo.gql";

// eslint-disable-next-line import/no-default-export

type HeaderLogoProps = { white?: boolean } & storeLogoQuery;
export default function HeaderLogo({ white = false, storeLogo }: HeaderLogoProps) {

  return (
    <Link href="/" className="relative text-right justify-start h-10 992:h-16 w-32 992:w-48">
      <Image src="/logo.png" alt="اُردمی مرجع تخصصی محصولات آرایشی، بهداشتی و تندرستی" fill className="object-contain"
        style={white ? { filter: "brightness(0) invert(1)" } : { filter: "none" }}
      />
    </Link>
  )
}
